
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M903.632711 56.947425H121.571464a114.346416 114.346416 0 0 0-113.894851 114.547112V690.393454a114.39659 114.39659 0 0 0 113.894851 114.597285H287.998432v121.621638a40.59072 40.59072 0 0 0 22.5281 36.426282 40.139154 40.139154 0 0 0 42.447156-4.314959l197.635161-153.732961h353.023862a114.346416 114.346416 0 0 0 113.844676-114.597285V171.494537a114.346416 114.346416 0 0 0-113.844676-114.547112z m33.164976 633.446029a33.365672 33.365672 0 0 1-33.164976 33.415846H536.861189a40.139154 40.139154 0 0 0-24.635406 8.479396L368.678132 843.925719v-79.525699a40.440198 40.440198 0 0 0-40.139154-40.59072H121.571464a33.365672 33.365672 0 0 1-33.215151-33.415846V171.494537a33.315498 33.315498 0 0 1 33.215151-33.365672H903.632711a33.315498 33.315498 0 0 1 33.164976 33.365672z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M222.220393 453.2714a60.961341 60.610123 90 1 0 121.220246 0 60.961341 60.610123 90 1 0-121.220246 0Z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M451.966877 453.2714a60.961341 60.610123 90 1 0 121.220246 0 60.961341 60.610123 90 1 0-121.220246 0Z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M681.713362 453.2714a60.961341 60.610123 90 1 0 121.220246 0 60.961341 60.610123 90 1 0-121.220246 0Z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  